import type { SVGProps } from 'react';
const SvgChannelWidget = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    {...props}
  >
    <g clipPath="url(#channel-widget_svg__a)">
      <path
        fill="#000"
        fillOpacity={0.86}
        d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24"
      />
      <path
        fill="#fff"
        d="M29 11.5H19c-4.375 0-6.25 2.5-6.25 6.25v12.5c0 3.75 1.875 6.25 6.25 6.25h10c4.375 0 6.25-2.5 6.25-6.25v-12.5c0-3.75-1.875-6.25-6.25-6.25m-6.837 18.088a.943.943 0 0 1 0 1.325.93.93 0 0 1-.663.274.93.93 0 0 1-.663-.274l-2.5-2.5a.943.943 0 0 1 0-1.326l2.5-2.5a.943.943 0 0 1 1.326 0 .943.943 0 0 1 0 1.326l-1.838 1.837zm7.5-1.175-2.5 2.5a.93.93 0 0 1-.663.274.93.93 0 0 1-.663-.274.943.943 0 0 1 0-1.326l1.838-1.837-1.838-1.837a.943.943 0 0 1 0-1.326.943.943 0 0 1 1.326 0l2.5 2.5a.943.943 0 0 1 0 1.326m2.462-7.85h-2.5a3.436 3.436 0 0 1-3.437-3.438v-2.5c0-.512.425-.937.937-.937s.938.425.938.937v2.5c0 .863.7 1.563 1.562 1.563h2.5c.513 0 .938.425.938.937a.944.944 0 0 1-.938.938"
      />
    </g>
    <defs>
      <clipPath id="channel-widget_svg__a">
        <path fill="#fff" d="M0 0h48v48H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgChannelWidget;
